/*!
 * Viewport Extra v2.1.4
 * (c) dsktschy
 * Released under the MIT License.
 */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

var getHTMLMetaElement = function (document, name, ensuring) {
    var selector = "meta[name=\"" + name + "\"]";
    var htmlMetaElement = document.querySelector(selector);
    if (!htmlMetaElement) {
        htmlMetaElement = document.createElement('meta');
        htmlMetaElement.setAttribute('name', name);
        if (ensuring)
            document.head.appendChild(htmlMetaElement);
    }
    return htmlMetaElement;
};
var getClientWidth = function (document) {
    return document.documentElement.clientWidth;
};

/**
 * Minimum kebab-to-camel converter
 * Complicated string can not be handled
 */
var camelize = function (value) {
    return value
        .replace(/\s+/g, '')
        .toLowerCase()
        .replace(/-./g, function (s) { return s.charAt(1).toUpperCase(); });
};
/**
 * Minimum camel-to-kebab converter
 * Complicated string can not be handled
 */
var kebabize = function (value) {
    return value
        .replace(/\s+/g, '')
        .replace(/[A-Z]+/g, function (s) { return "-" + s.charAt(0); })
        .toLowerCase();
};

var createPartialContent = function (htmlMetaElement) {
    var contentAttributeValue = htmlMetaElement.getAttribute('content') || '';
    var dataExtraContentAttributeValue = htmlMetaElement.getAttribute('data-extra-content') || '';
    var equalSeparatedContentList = __spreadArrays(contentAttributeValue.split(','), dataExtraContentAttributeValue.split(','));
    var partialContent = {};
    for (var _i = 0, equalSeparatedContentList_1 = equalSeparatedContentList; _i < equalSeparatedContentList_1.length; _i++) {
        var equalSeparatedContent = equalSeparatedContentList_1[_i];
        var _a = equalSeparatedContent.split('='), key = _a[0], value = _a[1];
        // If empty string is splitted, key will be empty string
        var trimmedKey = key.trim();
        if (!trimmedKey)
            continue;
        // If empty string is splitted, value will be undefined
        var trimmedValue = value ? value.trim() : '';
        if (!trimmedValue)
            continue;
        partialContent[camelize(trimmedKey)] = isNaN(+trimmedValue)
            ? trimmedValue
            : +trimmedValue;
    }
    return partialContent;
};
var applyContent = function (htmlMetaElement, content, documentClientWidth) {
    // Calculate width and initial-scale
    var width = content.width, initialScale = content.initialScale;
    var minWidth = content.minWidth, maxWidth = content.maxWidth, omittedContent = __rest(content, ["minWidth", "maxWidth"]);
    if (minWidth > maxWidth) {
        // eslint-disable-next-line no-console
        console.warn('Viewport Extra received minWidth that is greater than maxWidth, so they are ignored.');
    }
    else if (typeof width === 'number') {
        // eslint-disable-next-line no-console
        console.warn('Viewport Extra received fixed width, so minWidth and maxWidth are ignored.');
    }
    else if (documentClientWidth < minWidth) {
        omittedContent.width = minWidth;
        omittedContent.initialScale =
            (documentClientWidth / minWidth) * initialScale;
    }
    else if (documentClientWidth > maxWidth) {
        omittedContent.width = maxWidth;
        omittedContent.initialScale =
            (documentClientWidth / maxWidth) * initialScale;
    }
    // Stringify Content
    var contentAttributeValue = Object.keys(omittedContent)
        .map(function (key) { return kebabize(key) + "=" + omittedContent[key]; })
        .sort() // For testing
        .join(',');
    // Apply to HTMLMetaElement
    htmlMetaElement.setAttribute('content', contentAttributeValue);
};

var isContentWidth = function (value) {
    return (typeof value === 'number' && value > 0 && value < Infinity) ||
        value === 'device-width';
};
var isContentInitialScale = function (value) {
    return typeof value === 'number' && value >= 0 && value <= 10;
};
var isContentMinWidth = function (value) {
    return typeof value === 'number' && value >= 0 && value < Infinity;
};
var isContentMaxWidth = function (value) {
    return typeof value === 'number' && value > 0 && value <= Infinity;
};
var defaultProps = {
    width: 'device-width',
    initialScale: 1,
    minWidth: 0,
    maxWidth: Infinity
};
var create = function (partialContent) {
    var content = __assign({}, defaultProps);
    for (var _i = 0, _a = Object.keys(partialContent); _i < _a.length; _i++) {
        var key = _a[_i];
        var value = partialContent[key];
        if (value == null ||
            (key === 'width' && !isContentWidth(value)) ||
            (key === 'initialScale' && !isContentInitialScale(value)) ||
            (key === 'minWidth' && !isContentMinWidth(value)) ||
            (key === 'maxWidth' && !isContentMaxWidth(value))) {
            // eslint-disable-next-line no-console
            console.warn("Viewport Extra received invalid " + key + ", so it is discarded.");
            continue;
        }
        content[key] = value;
    }
    return content;
};

var viewportElement = null;
var viewportExtraElement = null;
var content = create({});
if (typeof window !== 'undefined') {
    viewportElement = getHTMLMetaElement(document, 'viewport', true);
    viewportExtraElement = getHTMLMetaElement(document, 'viewport-extra', false);
    // Create content object in advance
    // before default content is applied to viewport meta element
    var partialContent = __assign(__assign({}, createPartialContent(viewportElement)), createPartialContent(viewportExtraElement));
    // Apply default content to viewport meta element
    // in order to calculate correct value by getClientWidth
    // even if viewport meta element has no content attribute
    applyContent(viewportElement, content, 0);
    content = create(partialContent);
    applyContent(viewportElement, content, getClientWidth(document));
}
var setContent = function (partialContent) {
    if (typeof window === 'undefined' || !viewportElement)
        return;
    content = create(__assign(__assign({}, content), partialContent));
    applyContent(viewportElement, content, getClientWidth(document));
};
var getContent = function () { return content; };
var updateReference = function () {
    if (typeof window === 'undefined')
        return;
    viewportElement = getHTMLMetaElement(document, 'viewport', true);
};
// For compatibility with v1
var ViewportExtra = /** @class */ (function () {
    function ViewportExtra(partialContentOrContentMinWidth) {
        var partialContent = typeof partialContentOrContentMinWidth === 'number'
            ? { minWidth: partialContentOrContentMinWidth }
            : partialContentOrContentMinWidth;
        setContent(partialContent);
    }
    ViewportExtra.setContent = setContent;
    ViewportExtra.getContent = getContent;
    ViewportExtra.updateReference = updateReference;
    return ViewportExtra;
}());

export default ViewportExtra;
export { getContent, setContent, updateReference };
